var styles = {
  "Inline": "Polaris-Inline"
};

export { styles as default };
